import { List, Map } from 'immutable';
import {
  records as jobsRecords,
  types as jobsTypes,
} from '@saucelabs/sl-module-jobs';
import { transition, statusToEvent, State } from '@saucelabs/ds-job-card';

import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from './constants';
import { types as filterTypes } from '../filters';
import * as types from './types';

const initialState = Map({
  headlessAutomated: List(),
  headlessAutomatedLoading: true,
  page: DEFAULT_PAGE,
  perPage: DEFAULT_PAGE_SIZE,
  totalJobs: 0,
  runningStates: Map(),
});

const toggleLoader = (mutable, turnOnLoader = true) => (
  mutable
    .set('headlessAutomatedLoading', turnOnLoader)
);

const jobsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case jobsTypes.AUTOMATED_JOBS_GET.FAILURE:
      return state.set('headlessAutomatedLoading', false);
    case jobsTypes.JOBS_GET.SUCCESS:
    case jobsTypes.AUTOMATED_JOBS_GET.SUCCESS: {
      const jobs = payload.jobs?.map((job) => new jobsRecords.JobRecord(job));
      return state.withMutations((mutable) => (
        mutable
          .set('headlessAutomated', List(jobs))
          .set('headlessAutomatedLoading', false)
      ));
    }

    case types.ARCHIVED_JOBS_GET.SUCCESS: {
      const jobs = payload.jobs
        ?.map((job) => new jobsRecords.JobRecord({
          ...job,
          // NOTE: Archived jobs has a slightly different shape than resto jobs
          // so do some normalization here.
          assigned_tunnel_id: job.tunnel_id,
          browser: job.browser_name?.toLowerCase(),
          build: job.build_name,
          // NOTE: using a string template causes an eslint error that requires a package update:
          // see: https://github.com/eslint/eslint/issues/13542
          // eslint-disable-next-line prefer-template
          os: job.os + ' ' + job.os_version,
          status: (job.status === 'in progress' ? 'running' : job.status),
        }));

      const jobStates = jobs?.map((job) => {
        const { id } = job;
        const currentState = state.get('runningStates').get(id) || State.INIT;
        const event = statusToEvent(job.getStatus());
        const newState = transition(currentState, event);

        return [id, newState];
      });

      return state.withMutations((mutable) => (
        mutable
          .set('headlessAutomated', List(jobs))
          .set('headlessAutomatedLoading', false)
          .set('runningStates', Map(jobStates))
          .set('totalJobs', payload.total)
      ));
    }

    case types.CHANGE_PAGE:
      return state.withMutations((mutable) => {
        mutable.set('page', payload);
        toggleLoader(mutable, true);
      });
    case types.CHANGE_PER_PAGE:
      return state.withMutations((mutable) => {
        mutable.set('perPage', payload);
        toggleLoader(mutable, true);
      });
    case types.RESET_PAGE:
      return state.withMutations((mutable) => {
        mutable.set('page', initialState.get('page'));
        toggleLoader(mutable, true);
      });

    case filterTypes.TOGGLE_STATUS:
    case filterTypes.SELECT_OWNER:
    case filterTypes.CLEAR_OWNER:
    case filterTypes.CLEAR_STATUSES:
      return state.set('headlessAutomatedLoading', true);
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default jobsReducer;
